module.exports = __webpack_public_path__ + "files/d427b1d8ca7325182676ad15f4da983f.png";